jQuery(document).ready(function ($) {
    const $lightbox = $('#gallery-lightbox');

    if (!$lightbox.length) return;

    const $wrapper = $lightbox.find('.gallery-lightbox__gallery--container');
    const $current = $lightbox.find('.gallery-lightbox__gallery--counter .current');
    const $total = $lightbox.find('.gallery-lightbox__gallery--counter .total');

    let lightbox_swiper = null;

    function update_counter(swiper) {
        const slide_number = swiper.realIndex + 1;
        $current.text(String(slide_number).padStart(2, '0'));
    }

    function open_lightbox(urls, start_index) {
        if (lightbox_swiper) {
            lightbox_swiper.destroy(true, true);
            lightbox_swiper = null;
        }

        $wrapper.empty();

        urls.forEach(function (url) {
            $wrapper.append(
                $('<div>', { class: 'gallery-lightbox__gallery--image swiper-slide' }).append(
                    $('<img>', { src: url, alt: '' })
                )
            );
        });

        $total.text(' / ' + String(urls.length).padStart(2, '0'));

        lightbox_swiper = new Swiper('#gallery-lightbox .gallery-lightbox__gallery', {
            loop: urls.length > 1,
            slidesPerView: 1,
            slidesPerGroup: 1,
            grabCursor: true,
            spaceBetween: 24,
            initialSlide: start_index || 0,
            navigation: {
                prevEl: '.gallery-lightbox__gallery--prev',
                nextEl: '.gallery-lightbox__gallery--next'
            },
            on: {
                init: update_counter,
                slideChange: update_counter
            }
        });

        $lightbox.addClass('is-open').attr('aria-hidden', false);
        $('body').addClass('gallery-lightbox-open');
    }

    function close_lightbox() {
        $lightbox.removeClass('is-open').attr('aria-hidden', true);
        $('body').removeClass('gallery-lightbox-open');
    }

    $(document).on('click', '.js-gallery-lightbox-toggle', function (event) {
        event.preventDefault();

        const $gallery = $(this).closest('.js-gallery-lightbox');

        if (!$gallery.length) return;

        const urls = (($gallery.attr('data-gallery-lightbox-urls') || ''))
            .split(',')
            .map(function (url) { return url.trim(); })
            .filter(Boolean);

        if (!urls.length) return;

        const $image = $(this).find('img').first();
        const start_index = $image.length ? Math.max(urls.indexOf($image.attr('src')), 0) : 0;

        open_lightbox(urls, start_index);
    });

    $(document).on('click', '.js-gallery-lightbox-close', function (event) {
        event.preventDefault();
        close_lightbox();
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $lightbox.hasClass('is-open')) {
            close_lightbox();
        }
    });
});